<template>
    <status-button :state="running" :error="!!error">
        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="icon broadcast light" viewBox="0 0 512 512"><path d="M380.235 200.827l-11.017-6.592c-4.306-2.577-5.933-8.043-3.676-12.524 8.6-17.079 13.112-36.03 13.112-55.32 0-19.289-4.511-38.238-13.112-55.317-2.256-4.482-.63-9.948 3.677-12.524l11.017-6.593c4.756-2.846 10.927-1.07 13.45 3.865 11.127 21.757 16.968 45.95 16.968 70.568 0 24.622-5.841 48.816-16.968 70.573-2.524 4.934-8.695 6.71-13.451 3.864zM462.674 250.151l-11.037-6.61a9.565 9.565 0 01-3.489-12.773c17.323-31.911 26.44-67.803 26.44-104.378 0-36.571-9.116-72.462-26.439-104.374a9.565 9.565 0 013.489-12.773l11.037-6.61c4.673-2.799 10.731-1.137 13.34 3.644 20.03 36.71 30.572 78.023 30.572 120.113 0 42.093-10.543 83.408-30.573 120.117-2.608 4.781-8.667 6.443-13.34 3.644zM130.939 200.827l11.017-6.592c4.306-2.577 5.933-8.043 3.676-12.524-8.6-17.079-13.112-36.03-13.112-55.32 0-19.289 4.511-38.238 13.112-55.317 2.256-4.482.63-9.948-3.677-12.524l-11.017-6.593c-4.756-2.846-10.927-1.07-13.45 3.865-11.127 21.757-16.968 45.95-16.968 70.568 0 24.622 5.841 48.816 16.968 70.573 2.524 4.934 8.695 6.71 13.451 3.864zM48.5 250.151l11.037-6.61a9.565 9.565 0 003.489-12.773c-17.323-31.911-26.44-67.803-26.44-104.378 0-36.571 9.116-72.462 26.439-104.374a9.565 9.565 0 00-3.489-12.773l-11.037-6.61c-4.673-2.799-10.731-1.137-13.34 3.644C15.129 42.987 4.587 84.3 4.587 126.39c0 42.093 10.543 83.408 30.573 120.117 2.608 4.781 8.667 6.443 13.34 3.644zM374.663 467.147l-88.565-288.553c18.85-11.06 31.221-32.017 29.884-55.691-1.735-30.713-26.745-55.483-57.473-56.937-34.679-1.64-63.416 26.1-63.416 60.425 0 22.232 12.065 41.69 29.983 52.202L136.51 467.147c-1.792 5.837 2.574 11.744 8.68 11.744h12.686c5.053 0 9.515-3.298 10.998-8.13l22.52-73.37H319.78l22.519 73.37a11.505 11.505 0 0010.998 8.13h12.686c6.106 0 10.472-5.907 8.68-11.744zm-88.011-177.69h-62.13l31.065-101.212 31.065 101.213zm-31.065-191.56c15.711 0 28.494 12.782 28.494 28.494 0 15.711-12.783 28.493-28.494 28.493s-28.494-12.782-28.494-28.493c0-15.712 12.783-28.494 28.494-28.494zm-54.371 267.494l13.484-43.933h81.774l13.484 43.933H201.216z"></path></svg>
        SermonAudio: {{ name }}
    </status-button>
</template>

<style lang="scss" scoped>
.icon {
    height: 1em;
    margin-right: .25rem;
}
</style>

<script>
import axios from 'axios';
import StatusButton from '@/components/basics/StatusButton';

const checkUrl = "https://api.sermonaudio.com/v2/node/webcasts";

export default {
    name: "SermonAudioWebcastStatus",
    niceName: "SermonAudio Webcast Status Badge",
    description: "Shows status of given broadcaster",
    options: {
        broadcaster: {
            name: "Broadcaster",
            type: "select",
            description: "SermonAudio Broadcaster ID",
            options(){
                return this.$store.getters['sermonaudio/broadcasters'];
            },
        },
    },
    width: 2,
    height: 1,

    // Vue
    data() {
        return {
            running: false,
            info: {},
            checkInterval: null,
            error: false,
        };
    },
    components: {
        StatusButton,
    },
    props: {
        broadcaster: [Number, String],
    },
    mounted() {
        const self = this;
        this.checkInterval = setInterval(this.update, 5000); // every second, check if running
    },
    computed: {
        key(){
            return this.$store.state.sermonaudio.broadcasters[this.broadcaster].apiKey;
        },
        name(){
            return this.$store.state.sermonaudio.broadcasters[this.broadcaster].name;
        },
    },
    methods: {
        update(){
            axios.get(checkUrl, {
                headers: {
                    'X-API-Key': this.key,
                },
            }).then(function(response){
                const broadcastInfo = response.data.totalCount;
                if (broadcastInfo === undefined || broadcastInfo === null) {
                    self.running = false;
                    self.info = {};
                } else {
                    self.running = true;
                    self.info = response.data;
                }
            }).catch(function(err){
                self.error = err;
            });
        },
    },
    destroyed() {
        clearInterval(this.checkInterval);
    },
};
</script>
